import { render, staticRenderFns } from "./ydtj.vue?vue&type=template&id=797cb380&"
import script from "./ydtj.vue?vue&type=script&lang=js&"
export * from "./ydtj.vue?vue&type=script&lang=js&"
import style0 from "./ydtj.vue?vue&type=style&index=0&id=797cb380&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports